(function($) {
	$.fn.fontResize = function(options) {
		var settings = {
			increaseBtn : $('#increase-font'),
			decreaseBtn : $('#decrease-font')
		};
		options = $.extend(settings, options);

		return this.each(function() {
			var element = $(this);
              
			options.increaseBtn.on('click', function(e) {
                console.log('increasing font');
				e.preventDefault();
				
				var scrHeight = element.get(0).scrollHeight;
				scrHeight = parseFloat(scrHeight)-parseFloat($('#text').css('padding-top'));
                if(scrHeight < 45){
                  var baseFontSize = parseFloat(element.css('font-size'));
                  console.log(baseFontSize);
				  element.css('font-size', (baseFontSize + .50) + 'px');
                  setPadding();
                }
			});

			options.decreaseBtn.on('click', function(e) {
				e.preventDefault();
				var baseFontSize = parseFloat(element.css('font-size'));
                var _paddingtop = parseFloat(element.css('padding-top'));
                console.log('baseFontSize');
                console.log(baseFontSize);
				element.css('font-size', (baseFontSize - .50) + 'px');
				element.css('padding-top', '14px');
                setPadding();
			});

		});

	};

})(jQuery);
function setPadding(){
            var _first = $('#text').get(0).scrollHeight;
            var _second = $('#text').css('padding-top');
            var _result = parseFloat(_first)-parseFloat(_second);
            console.log('_result '+_result);
            var textareaHeight = 45;
            var Fpadding = Math.max( 0, ( textareaHeight - _result ) );
            $('#text').css('padding-top',Fpadding);
            return Fpadding;
        }